
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 88.54 88.54"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Lager_2","data-name":"Lager 2"}},[_c('g',{attrs:{"id":"Lager_1-2","data-name":"Lager 1"}},[_c('circle',{attrs:{"cx":"44.27","cy":"44.27","r":"44.27","fill":"#ee7203"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M17.25 51h-4.74V37.26H10v-4h7.26zM37.71 42.09a9.43 9.43 0 01-2.28 6.64 7.7 7.7 0 01-5.94 2.47 7.7 7.7 0 01-5.94-2.47 9.43 9.43 0 01-2.28-6.64 9.32 9.32 0 012.27-6.59 7.71 7.71 0 015.95-2.45 7.71 7.71 0 015.95 2.45 9.32 9.32 0 012.27 6.59zm-11.6 0A6.46 6.46 0 0027 45.8a2.95 2.95 0 004.94 0 6.46 6.46 0 00.91-3.69 6.52 6.52 0 00-.9-3.66 3 3 0 00-5 0 6.52 6.52 0 00-.84 3.66zM57.15 42.09a9.42 9.42 0 01-2.27 6.64 7.7 7.7 0 01-5.94 2.47A7.67 7.67 0 0143 48.73a9.43 9.43 0 01-2.28-6.64A9.36 9.36 0 0143 35.5a7.75 7.75 0 016-2.45 7.73 7.73 0 016 2.45 9.32 9.32 0 012.15 6.59zm-11.59 0a6.46 6.46 0 00.91 3.69 2.95 2.95 0 004.94 0 6.54 6.54 0 00.91-3.69 6.52 6.52 0 00-.9-3.66 3 3 0 00-5 0 6.52 6.52 0 00-.86 3.68zM68.83 37.21a4 4 0 01-1.28 3 4.32 4.32 0 01-3.09 1.22 4.38 4.38 0 01-3.11-1.22 4.07 4.07 0 010-5.92 4.39 4.39 0 013.12-1.21 4.34 4.34 0 013.09 1.2 3.9 3.9 0 011.27 2.93zM65.5 51h-3.43l11.1-17.68h3.43zm-2.26-13.79a1.33 1.33 0 00.34 1 1.11 1.11 0 00.88.37 1.12 1.12 0 00.88-.37 1.33 1.33 0 00.34-1 1.29 1.29 0 00-.35-.93 1.13 1.13 0 00-.87-.37 1.11 1.11 0 00-.88.37 1.29 1.29 0 00-.34.93zM78.55 47a3.93 3.93 0 01-1.27 3 4.58 4.58 0 01-6.2 0 4.07 4.07 0 010-5.93 4.62 4.62 0 016.22 0A3.9 3.9 0 0178.55 47zM73 47a1.37 1.37 0 00.34 1 1.15 1.15 0 00.88.36 1.17 1.17 0 00.89-.36 1.41 1.41 0 00.34-1 1.33 1.33 0 00-.34-.91 1.28 1.28 0 00-1.77 0A1.26 1.26 0 0073 47z"}})])])])
          )
        }
      }
    